import * as pdfjsLib from 'pdfjs-dist'
import pdfWorkerUrl from 'pdfjs-dist/build/pdf.worker.min.mjs?url'

// Keep the worker and the font/CMap/image decoders on our own origin and at
// exactly the installed PDF.js version. Image codecs moved to runtime assets
// in newer PDF.js releases; a worker alone leaves some scans blank.
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorkerUrl

export function loadPdfDocument(options: NonNullable<Parameters<typeof pdfjsLib.getDocument>[0]>) {
  const assets = new URL(`${import.meta.env.BASE_URL}pdfjs-assets/`, document.baseURI)
  return pdfjsLib.getDocument({
    cMapUrl: new URL('cmaps/', assets).href,
    cMapPacked: true,
    standardFontDataUrl: new URL('standard_fonts/', assets).href,
    wasmUrl: new URL('wasm/', assets).href,
    ...options,
  })
}
